import { Cell, TableData } from 'utils/data'
import { isStore } from 'utils/location'
import { MetricConfig } from './theft/theft-store.constants'

export const addHyperlinkToFirstColumn = (
    data: TableData,
    currentLocation: string,
    pathname?: string,
) => {
    if (data) {
        const { rows } = data
        if (Array.isArray(rows)) {
            data.rows = rows.map((row, index) => {
                const locationCell = row[0]
                if (index === 0) {
                    return row
                }
                if (!isStore(currentLocation)) {
                    locationCell.url =
                        (pathname ?? '') +
                        '?locationId=' +
                        (locationCell.value || '')
                }
                return row
            })
        } else {
            data.rows = []
        }
    }
    return data
}

export const updateTableHeaders = (
    data: TableData,
    customHeaders: string[] = [],
): TableData => {
    if (data) {
        if (!Array.isArray(data.rows)) {
            data.rows = []
        }

        data.headings = customHeaders.map((header) => ({ value: header }))
    }
    return data
}

export const buildDataForTheftRDG = (
    internalData: TableData,
    externalData: TableData,
    currentLocation: string,
    internalHeaders: Array<string>,
    externalHeaders: Array<string>,
    internalTitle: string,
    externalTitle: string,
) => {
    if (internalData) {
        internalData = addHyperlinkToFirstColumn(internalData, currentLocation)
        internalData = updateTableHeaders(internalData, internalHeaders)
    }

    if (externalData) {
        externalData = addHyperlinkToFirstColumn(externalData, currentLocation)
        externalData = updateTableHeaders(externalData, externalHeaders)
    }
    const combinedData = [
        { title: internalTitle, table: internalData },
        { title: externalTitle, table: externalData },
    ]
    return combinedData
}
export const pickColumns = (
    data: TableData | undefined,
    columnIndexes: number[],
) => {
    // Needed so typescript knows that in the .map for newHeadings, data.headings will exist
    const dataHeadings = data?.headings
    if (!data || !Array.isArray(dataHeadings) || !Array.isArray(data.rows)) {
        return {
            headings: [],
            rows: [],
        }
    }

    const newHeadings = columnIndexes.map((index) => dataHeadings[index])
    const newRows = data.rows.map((row) =>
        columnIndexes.map((index) => row[index]),
    )

    return {
        headings: newHeadings,
        rows: newRows,
    }
}

export const buildTheftStoreTransposedTableData = (
    table: TableData,
    metricConfigs: MetricConfig[],
    headings: Cell[],
): TableData => {
    if (!table.rows || table.rows.length === 0) {
        return { headings, rows: [], footer: [] }
    }

    const rows = table.rows.flatMap((row) =>
        metricConfigs.map((metric) => {
            const bpCell =
                metric.bpValue !== undefined
                    ? { value: metric.bpValue, raw: metric.bpValue }
                    : row[metric.bpIndex!]

            const cells: Cell[] = [
                { value: metric.name, raw: metric.name },
                row[metric.ytdIndex],
                bpCell,
            ]

            if (metric.daysIndex !== undefined) {
                cells.push(row[metric.daysIndex])
            }

            return cells
        }),
    )

    return { headings, rows, footer: [] }
}
